import React, { useEffect, useState } from "react";
import { PrimatyAddressPreQualType, SingleBusinessAddressType } from "types";
import {
  trackFormError,
  trackPageViewUserStep,
  trackSaveAndContinueUserStep,
} from "utils/analytics/trackEvent";
import AddressDropdown from "./components/AddressDropdown";
import PrimaryAddressEditForm from "./components/PrimaryAddressEditForm";
import PrimaryBusinessAddressForm from "./components/PrimaryAddressForm";
import Stepper from "uicomponents/Stepper";
import { errorMessageMap, getStepNumberFromURL } from "utils/helper";
import styles from "../../PreQualification.module.css";
import { STEPS } from "pages/PreQualification/utils/constants";
import { usePreQualContext } from "pages/PreQualification/PreQualification";
import { useUpdateStepMutation } from "types/generated/operations";
import Error, { EErrorType } from "uicomponents/Error";
import Alert from "uicomponents/Alert";
interface IPrimaryBusinessAddressProps {
  data: PrimatyAddressPreQualType;
}

const PrimaryBusinessAddress = ({
  ...props
}: IPrimaryBusinessAddressProps): JSX.Element => {
  const { data } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageViewUserStep(1, "primary business address");
  }, []);

  const { stepperNextStep, nextStep } = usePreQualContext();
  const [updateStep] = useUpdateStepMutation();
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const isNotEligibleForCoverage =
    data?.healthInsuranceInformation?.isCoverageEligible === false;

  const primaryaddress = data?.officeLocations?.filter(
    (address: SingleBusinessAddressType) => address.isHq === true
  );

  const hasPrimaryaddress = data?.officeLocations?.some(
    (address: SingleBusinessAddressType) => address.isHq === true
  );

  const hasAddressOnFile = (data?.officeLocations?.length ?? 0) > 0;

  const handleNextClick = async () => {
    try {
      const currentStep = getStepNumberFromURL();
      if (data?.applications?.[0]?.step === currentStep) {
        await updateStep({
          variables: {
            uuid: data?.applications?.[0].uuid,
            step: data?.applications?.[0]?.step + 1,
          },
        });
        trackSaveAndContinueUserStep(currentStep, "Current Coverage");
      }
      nextStep();
    } catch (error: any) {
      const errorMessage: string = error?.message;
      errorMessageMap[errorMessage] &&
        setErrorMessage(errorMessageMap[errorMessage]);
      trackFormError(error, errorMessage);
      setIsError(true);
      return;
    }
  };

  const applicationStep = data?.applications?.[0]?.step;
  const currentStep = getStepNumberFromURL();
  const isInValidStep = applicationStep && currentStep > applicationStep;

  if (isInValidStep) {
    return <Error />;
  }

  if (isNotEligibleForCoverage) {
    return <Error type={EErrorType.NotEligibleForCoverage} />;
  }

  return (
    <div className={styles.prequalformContainer}>
      <Stepper
        steps={STEPS}
        currentStep={getStepNumberFromURL()}
        status={data?.applications?.[0].step || 1}
        onClick={(stepNumber) => stepperNextStep(stepNumber)}
      />
      <div className={styles.prequalformDiv}>
        {hasPrimaryaddress && (
          <PrimaryAddressEditForm
            data={primaryaddress?.[0]}
            handleNextClick={handleNextClick}
          />
        )}
        {!hasPrimaryaddress && !hasAddressOnFile && (
          <PrimaryBusinessAddressForm
            data={primaryaddress?.[0]}
            handleNextClick={handleNextClick}
          />
        )}
        {!hasPrimaryaddress && hasAddressOnFile && (
          <AddressDropdown data={data} handleNextClick={handleNextClick} />
        )}
        {isError && <Alert message={errorMessage} />}
      </div>
    </div>
  );
};
export default PrimaryBusinessAddress;
